import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

export function useResponsive() {
  const theme = useTheme();

  return {
    isMobile: useMediaQuery(theme.breakpoints.down("sm")),
    isTablet: useMediaQuery(theme.breakpoints.between("sm", "md")),
    isDesktop: useMediaQuery(theme.breakpoints.up("md")),
    isLargeScreen: useMediaQuery(theme.breakpoints.up("lg")),
    // Legacy support for existing code patterns
    isMobileQuery: useMediaQuery("(max-width: 768px)"),
    isMobileQueryDefault: useMediaQuery("(max-width: 949px) and (max-height: 599px)"),
  };
}
